export const STATE_CENTERS: {
  [key: string]: { LATITUDE: number; LONGITUDE: number };
} = {
  AL: { LATITUDE: 32.806671, LONGITUDE: -86.79113 },
  AK: { LATITUDE: 61.370716, LONGITUDE: -152.404419 },
  AZ: { LATITUDE: 33.729759, LONGITUDE: -111.431221 },
  AR: { LATITUDE: 34.969704, LONGITUDE: -92.373123 },
  CA: { LATITUDE: 36.116203, LONGITUDE: -119.681564 },
  CO: { LATITUDE: 39.059811, LONGITUDE: -105.311104 },
  CT: { LATITUDE: 41.597782, LONGITUDE: -72.755371 },
  DE: { LATITUDE: 39.318523, LONGITUDE: -75.507141 },
  FL: { LATITUDE: 27.766279, LONGITUDE: -81.686783 },
  GA: { LATITUDE: 33.040619, LONGITUDE: -83.643074 },
  HI: { LATITUDE: 21.094318, LONGITUDE: -157.498337 },
  ID: { LATITUDE: 44.240459, LONGITUDE: -114.478828 },
  IL: { LATITUDE: 40.349457, LONGITUDE: -88.986137 },
  IN: { LATITUDE: 39.849426, LONGITUDE: -86.258278 },
  IA: { LATITUDE: 42.011539, LONGITUDE: -93.210526 },
  KS: { LATITUDE: 38.5266, LONGITUDE: -96.726486 },
  KY: { LATITUDE: 37.66814, LONGITUDE: -84.670067 },
  LA: { LATITUDE: 31.169546, LONGITUDE: -91.867805 },
  ME: { LATITUDE: 44.693947, LONGITUDE: -69.381927 },
  MD: { LATITUDE: 39.063946, LONGITUDE: -76.802101 },
  MA: { LATITUDE: 42.230171, LONGITUDE: -71.530106 },
  MI: { LATITUDE: 43.326618, LONGITUDE: -84.536095 },
  MN: { LATITUDE: 45.694454, LONGITUDE: -93.900192 },
  MS: { LATITUDE: 32.741646, LONGITUDE: -89.678696 },
  MO: { LATITUDE: 38.456085, LONGITUDE: -92.288368 },
  MT: { LATITUDE: 46.921925, LONGITUDE: -110.454353 },
  NE: { LATITUDE: 41.12537, LONGITUDE: -98.268082 },
  NV: { LATITUDE: 38.313515, LONGITUDE: -117.055374 },
  NH: { LATITUDE: 43.452492, LONGITUDE: -71.563896 },
  NJ: { LATITUDE: 40.298904, LONGITUDE: -74.521011 },
  NM: { LATITUDE: 34.840515, LONGITUDE: -106.248482 },
  NY: { LATITUDE: 42.165726, LONGITUDE: -74.948051 },
  NC: { LATITUDE: 35.630066, LONGITUDE: -79.806419 },
  ND: { LATITUDE: 47.528912, LONGITUDE: -99.784012 },
  OH: { LATITUDE: 40.388783, LONGITUDE: -82.764915 },
  OK: { LATITUDE: 35.565342, LONGITUDE: -96.928917 },
  OR: { LATITUDE: 44.572021, LONGITUDE: -122.070938 },
  PA: { LATITUDE: 40.590752, LONGITUDE: -77.209755 },
  RI: { LATITUDE: 41.680893, LONGITUDE: -71.51178 },
  SC: { LATITUDE: 33.856892, LONGITUDE: -80.945007 },
  SD: { LATITUDE: 44.299782, LONGITUDE: -99.438828 },
  TN: { LATITUDE: 35.747845, LONGITUDE: -86.692345 },
  TX: { LATITUDE: 31.054487, LONGITUDE: -97.563461 },
  UT: { LATITUDE: 40.150032, LONGITUDE: -111.862434 },
  VT: { LATITUDE: 44.045876, LONGITUDE: -72.710686 },
  VA: { LATITUDE: 37.769337, LONGITUDE: -78.169968 },
  WA: { LATITUDE: 47.400902, LONGITUDE: -121.490494 },
  WV: { LATITUDE: 38.491226, LONGITUDE: -80.95457 },
  WI: { LATITUDE: 44.268543, LONGITUDE: -89.616508 },
  WY: { LATITUDE: 42.755966, LONGITUDE: -107.30249 },
};

export const US_CENTER = {
  LATITUDE: 39.8283,
  LONGITUDE: -98.5795,
};
